(function(angular) {
    /**
     * @ngdoc object
     * @name KeyboardActivatorController
     * @description Controller of the keyboardActivator directive
     */
    class KeyboardActivatorController {
        static get $inject() {
            return [
                '$scope',
                '$attrs'
            ];
        }

        constructor($scope, $attrs) {
            this.$scope = $scope;
            this.$attrs = $attrs;
            this.keyboardActive = $attrs.keyboardActivator;
        }

        $doCheck() {
            if (this.keyboardActive === this.$attrs.keyboardActivator) {
                return;
            }

            this.keyboardActive = this.$attrs.keyboardActivator;

            if (this.keyboardActive === 'true') {
                this.$scope.$broadcast('dropdown.show');
                return;
            }

            this.$scope.$broadcast('dropdown.hide');
        }

        $onDestroy() {
            this.$scope.$broadcast('dropdown.hide');
        }
    }

    angular.module('wtApp.wtSelector').directive('keyboardActivator', function() {
        return {
            restrict: 'A',
            controller: KeyboardActivatorController,
            bindToController: true
        };
    });
})(window.angular);
